module.exports = __webpack_public_path__ + "img/write_large.a3b3d2e5.webp";